<template>
  <div class="addClassBox">
    <el-dialog
      :title="firstTitle"
      custom-class="addClassPop"
      :visible.sync="dialogFormShow"
      @close="close"
    >
      <h6 class="secondTitle">
        {{ secondTitle }}
      </h6>
      <el-input
        v-model="inputValue"
        type="text"
        :placeholder="placeHolderText"
        maxlength="6"
        show-word-limit
        class="input"
      />
      <h6 class="secondTitle">
        {{ secondTitle2 }}
      </h6>
      <el-select v-model="selectValue" filterable placeholder="请选择">
        <el-option
          v-for="item in options"
          :key="item.value"
          :label="item.label"
          :value="item.value"
        />
      </el-select>
      <el-button class="button" type="primary" size="medium">确定</el-button>
    </el-dialog>
  </div>
</template>
<script>
export default {
  name: 'AddFieldProduct',
  props: {
    dialogFormVisible: {
      type: Boolean,
      default: false,
    },
    options: {
      type: Array,
      default: () => [],
    },
    firstTitle: {
      type: String,
      default: '添加领域',
    },
    secondTitle: {
      type: String,
      default: '产品名称',
    },
    secondTitle2: {
      type: String,
      default: '关联BU',
    },
    placeHolderText: {
      type: String,
      default: '请输入关联BU',
    },
  },
  data() {
    return {
      inputValue: '',
      dialogFormShow: this.dialogFormVisible,
      selectValue: '',
    };
  },
  watch: {
    dialogFormVisible(newValue) {
      this.dialogFormShow = newValue;
    },
  },
  methods: {
    close() {
      this.dialogFormShow = false;
      this.$emit('hideDialog');
    },
  },
};
</script>
<style lang="scss" scoped>
@import './index.scss';
</style>
